module.exports = __webpack_public_path__ + "static/media/unilever-coffee-girl.38b13fdb.png";